import request from '../../utils/request'

export const dashoard = {
  state: {
    tempSetData: 0,
    dataSaleProduct: [],
    dataSaleProductLo: [],
    dataPStyeList: [],
    dataUserUFList: [],
    dataUserDTList: [],
    dataRetentionList: [],
    totalMPU: 0,
    dateforGraph: '',
    faceGrapSale_Date: '',
    faceGrapSale_EDate: '',
    faceGrapSalelo_Date: '',
    faceGrapSalelo_EDate: '',
    faceGrapPStype_Date: '',
    faceGrapPStype_EDate: '',
    faceGraphUF_Date: '',
    faceGraphUF_EDate: '',
    faceGraphDT_Date: '',
    faceGraphDT_EDate: '',
  },
  reducers: {
    tempSetDataArr(state, payload) {
      return {
        ...state,
        tempSetData: payload
      }
    },
    setDateforGraph(state, payload) {
      return {
        ...state,
        dateforGraph: payload
      }
    },
    dataSaleProduct(state, payload) {
      return {
        ...state,
        dataSaleProduct: payload
      }
    },
    faceGrapSale_Date(state, payload) {
      return {
        ...state,
        faceGrapSale_Date: payload
      }
    },
    faceGrapSale_EDate(state, payload) {
      return {
        ...state,
        faceGrapSale_EDate: payload
      }
    },
    dataSaleProductLo(state, payload) {
      return {
        ...state,
        dataSaleProductLo: payload
      }
    },
    faceGrapSalelo_Date(state, payload) {
      return {
        ...state,
        faceGrapSalelo_Date: payload
      }
    },
    faceGrapSalelo_EDate(state, payload) {
      return {
        ...state,
        faceGrapSalelo_EDate: payload
      }
    },
    faceGrapPStype_Date(state, payload) {
      return {
        ...state,
        faceGrapPStype_Date: payload
      }
    },
    faceGrapPStype_EDate(state, payload) {
      return {
        ...state,
        faceGrapPStype_EDate: payload
      }
    },
    dataPStye(state, payload) {
      return {
        ...state,
        dataPStyeList: payload
      }
    },
    faceGraphUF_Date(state, payload) {
      return {
        ...state,
        faceGraphUF_Date: payload
      }
    },
    faceGraphUF_EDate(state, payload) {
      return {
        ...state,
        faceGraphUF_EDate: payload
      }
    },
    dataUserUF(state, payload) {
      return {
        ...state,
        dataUserUFList: payload
      }
    },
    faceGraphDT_Date(state, payload) {
      return {
        ...state,
        faceGraphDT_Date: payload
      }
    },
    faceGraphDT_EDate(state, payload) {
      return {
        ...state,
        faceGraphDT_EDate: payload
      }
    },
    dataUserDT(state, payload) {
      return {
        ...state,
        dataUserDTList: payload
      }
    },
    dataRetentionList(state, payload) {
      return {
        ...state,
        dataRetentionList: payload
      }
    },
    totalMPU(state, payload) {
      return {
        ...state,
        totalMPU: payload
      }
    }
  },

  effects: (dispatch) => ({
    async FaceGrapSale(date, getState) {
      let arr = []
      if (date !== undefined) {
        if (date.stateDate !== undefined && date.endDate !== undefined) {
          const res = await request.get(`/insight/sales/product/category?start_date=${date.stateDate}&end_date=${date.endDate}`)
          res.data.forEach((el, i) => {
            if (el.sales_values !== undefined) {
              for (let i = 0; i < el.sales_values.length; i++) {
                if (arr.length === 0) {
                  arr.push({
                    name: `${el.sales_values[i].name}`,
                    data: [el.sales_values[i].value]
                  })
                } else {
                  let index = arr.map(function (el) { return el.name; }).indexOf(`${el.sales_values[i].name}`);
                  if (index === -1 && index < 0) {
                    arr.push({
                      name: `${el.sales_values[i].name}`,
                      data: [el.sales_values[i].value]
                    })
                  } else if (index >= 0) {
                    arr[index].data.push(el.sales_values[index].value)
                  }
                }
              }
            }
          });
        }
        const cleanData = arr
        if (getState.dashoard.faceGrapSale_Date !== date.stateDate || getState.dashoard.faceGrapSale_EDate !== date.endDate) {
          dispatch.dashoard.faceGrapSale_Date(date.stateDate)
          dispatch.dashoard.faceGrapSale_EDate(date.endDate)
          dispatch.dashoard.dataSaleProduct(cleanData)
        }
      }

    },
    async  FaceGrapSaleBylocation(datelo, getState) {
      let arr = []
      if (datelo !== undefined) {
        if (datelo.stateDate !== undefined && datelo.endDate !== undefined) {
          const res = await request.get(`/insight/sales/location?start_date=${datelo.stateDate}&end_date=${datelo.endDate}`)
          res.data.forEach((el, i) => {
            if (el.sales_values !== undefined) {
              for (let i = 0; i < el.sales_values.length; i++) {
                if (arr.length === 0) {
                  arr.push({
                    name: `${el.sales_values[i].name}`,
                    data: [el.sales_values[i].value]
                  })
                } else {
                  let index = arr.map(function (el) { return el.name; }).indexOf(`${el.sales_values[i].name}`);
                  if (index === -1 && index < 0) {
                    arr.push({
                      name: `${el.sales_values[i].name}`,
                      data: [el.sales_values[i].value]
                    })
                  } else if (index >= 0) {
                    arr[index].data.push(el.sales_values[index].value)
                  }
                }
              }
            }
          });
        }
        const cleanData = arr
        if (getState.dashoard.faceGrapSalelo_Date !== datelo.stateDate || getState.dashoard.faceGrapSalelo_EDate !== datelo.endDate) {
          dispatch.dashoard.faceGrapSalelo_Date(datelo.stateDate)
          dispatch.dashoard.faceGrapSalelo_EDate(datelo.endDate)
          dispatch.dashoard.dataSaleProductLo(cleanData)
        }
      }

    },
    async FaceGraphPStype(date, getState) {
      let arr = []
      if (date !== undefined) {
        if (date.stateDate !== undefined && date.endDate !== undefined) {
          const res = await request.get(`/insight/sales/product/type?start_date=${date.stateDate}&end_date=${date.endDate}`)
          res.data.forEach((el, i) => {
            if (el.sales_values !== undefined) {
              for (let i = 0; i < el.sales_values.length; i++) {
                if (arr.length === 0) {
                  arr.push({
                    name: `${el.sales_values[i].name}`,
                    data: [el.sales_values[i].value]
                  })
                } else {
                  let index = arr.map(function (el) { return el.name; }).indexOf(`${el.sales_values[i].name}`);
                  if (index === -1 && index < 0) {
                    arr.push({
                      name: `${el.sales_values[i].name}`,
                      data: [el.sales_values[i].value]
                    })
                  } else if (index >= 0) {
                    arr[index].data.push(el.sales_values[index].value)
                  }
                }
              }
            }
          });
        }
      }
      const cleanData = arr
      if (getState.dashoard.faceGrapPStype_Date !== date.stateDate || getState.dashoard.faceGrapPStype_EDate !== date.endDate) {
        dispatch.dashoard.faceGrapPStype_Date(date.stateDate)
        dispatch.dashoard.faceGrapPStype_EDate(date.endDate)
        dispatch.dashoard.dataPStye(cleanData)
      }


    },
    async  FaceGraphUF(date, getState) {
      let arr = []
      if (date !== undefined) {
        if (date.stateDate !== undefined && date.endDate !== undefined) {
          const res = await request.get(`/insight/user/funnel?start_date=${date.stateDate}&end_date=${date.endDate}`)
          res.data.forEach((el, i) => {
            if (el.sales_values !== undefined) {
              for (let i = 0; i < el.sales_values.length; i++) {
                if (arr.length === 0) {
                  arr.push({
                    name: `${el.sales_values[i].name}`,
                    data: [el.sales_values[i].value]
                  })
                } else {
                  let index = arr.map(function (el) { return el.name; }).indexOf(`${el.sales_values[i].name}`);
                  if (index === -1 && index < 0) {
                    arr.push({
                      name: `${el.sales_values[i].name}`,
                      data: [el.sales_values[i].value]
                    })
                  } else if (index >= 0) {
                    arr[index].data.push(el.sales_values[index].value)
                  }
                }
              }
            }
          });
        }
      }
      const cleanData = arr

      if (getState.dashoard.faceGraphUF_Date !== date.stateDate || getState.dashoard.faceGraphUF_EDate !== date.endDate) {
        dispatch.dashoard.faceGraphUF_Date(date.stateDate)
        dispatch.dashoard.faceGraphUF_EDate(date.endDate)
        dispatch.dashoard.dataUserUF(cleanData)
      }

    },
    async  FaceGraphDT(date, getState) {
      let arr = []
      if (date !== undefined) {
        if (date.stateDate !== undefined && date.endDate !== undefined) {
          const res = await request.get(`/insight/appointment/datetime?start_date=${date.stateDate}&end_date=${date.endDate}`)
          res.data.forEach((el, i) => {
            if (el.sales_values !== undefined) {
              for (let i = 0; i < el.sales_values.length; i++) {
                if (arr.length === 0) {
                  arr.push({
                    name: `${el.sales_values[i].name}`,
                    data: [el.sales_values[i].value]
                  })
                } else {
                  let index = arr.map(function (el) { return el.name; }).indexOf(`${el.sales_values[i].name}`);
                  if (index === -1 && index < 0) {
                    arr.push({
                      name: `${el.sales_values[i].name}`,
                      data: [el.sales_values[i].value]
                    })
                  } else if (index >= 0) {
                    arr[index].data.push(el.sales_values[index].value)
                  }
                }
              }
            }
          });
        }
      }
      const cleanData = arr
      if (getState.dashoard.faceGraphDT_Date !== date.stateDate || getState.dashoard.faceGraphDT_EDate !== date.endDate) {
        dispatch.dashoard.faceGraphDT_Date(date.stateDate)
        dispatch.dashoard.faceGraphDT_EDate(date.endDate)
        dispatch.dashoard.dataUserDT(cleanData)
      }

    },
    
    async FaceserRetention(numCols) {
      let arr = [];
      dispatch.dashoard.dataRetentionList([]);
      dispatch.dashoard.totalMPU(0);
      const isMPU = window.location.href.includes("mpu");
      const res = await request.get(`/insight/retention/${isMPU ? 'mpu' : 'mau'}`, {
        params: {
          months: numCols,
        }
      });
      const months = res.data.months || [];
      const total_all_users = res.data.total_all_users || 0;
      for (let i = 0; i < months.length ; i++) {
        let retentionData = { date: `${months[i].month}`, total_user: months[i].total_user || 0 };
        for (let j = 0; j < numCols; j++) {
          retentionData[`col${j + 1}`] = months[i].retention[j] !== undefined ? `${months[i].retention[j].percentage} %` : null;
        }
        let index = arr.map(e => e.date).indexOf(`${months[i].month}`);
        if (index === -1) {
          arr.push(retentionData);
        }
      }
      const cleanData = arr;
      dispatch.dashoard.dataRetentionList(cleanData);
      dispatch.dashoard.totalMPU(total_all_users);
    }
  }),
}